"use client";
import { createNewChatImageTraits } from "@/app/(website)/chat/actions";
import { fetchImages } from "@/app/api/image/list/client";
import { Modal, useModal } from "@/lib/slices/modal.slice";
import { Image } from "@prisma/client";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { Mousewheel } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { SwipeMore } from "./SwipeMore";
import { descriptions } from "./descriptions";
import { femaleNames } from "./names";
interface CharactersProps {
  prefetchedImages: Image[];
  user: any;
}

const ProfileCard = dynamic(() => import("@/components/profile-card"), {
  ssr: false,
});

const getRandomName = () =>
  femaleNames[Math.floor(Math.random() * femaleNames.length)];
const getRandomDescription = () =>
  descriptions[Math.floor(Math.random() * descriptions.length)];

export default function SwipeableCharacters({
  prefetchedImages,
  user,
}: CharactersProps) {
  const router = useRouter();
  const { ref, inView } = useInView();
  const modals = useModal();

  const [images, setImages] = useState(prefetchedImages);

  async function loadMoreImages() {
    const nextImages = await fetchImages(10, images.length);

    setImages((prev) => {
      return [...prev, ...nextImages];
    });
  }

  useEffect(() => {
    if (inView) {
      loadMoreImages();
    }
  }, [inView]);

  return (
    <Swiper
      direction={"vertical"}
      className="mySwiper h-full"
      mousewheel={true}
      modules={[Mousewheel]}
    >
      {images?.map((image, idx) => {
        const name = getRandomName();
        const description = getRandomDescription();

        const isLoadMoreTriggerVisible = idx === images.length - 3;

        return (
          <SwiperSlide className="relative sm:pt-20" key={idx}>
            {isLoadMoreTriggerVisible && (
              <div ref={ref} className="absolute top-0 h-10 w-full" />
            )}
            <ProfileCard
              character={{
                name: name,
                description: description,
                avatar: image.imageUrl,
              }}
              onClick={async () => {
                if (user?.id) {
                  const chat = await createNewChatImageTraits(
                    name,
                    image.id,
                    "",
                  );

                  router.push(`/chat/chat-${chat?.id}`);
                } else {
                  modals.setActiveModal(Modal.LOGIN_MODAL);
                }
              }}
              withMatchBtn
              className="shadow-md aspect-auto lea h-full w-full mx-auto sm:w-auto sm:max-h-[calc(100dvh-3.5rem*2)] sm:aspect-[3/4] overflow-hidden"
              noRadiusOnMobile
              titleClassName="text-4xl font-semibold"
            />
          </SwiperSlide>
        );
      })}
      <SwipeMore />
    </Swiper>
  );
}
